import { computed, watch } from 'vue'

export default {
  components: {},
  props: {
    text: {
      type: String,
      default: '文字顯示文字顯示文字顯示'
    },
    isOpen: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const privateIsOpen = computed({
      get: () => props.isOpen,
      set: (val) => {
        emit('update:isOpen', val);
      }

    }) //end: privateIsOpen

    watch(
      () => props.isOpen,
      (val) => {
        if (val) {
          setTimeout(() => {
            privateIsOpen.value = false;
          }, 2000);
        }
      })

    return {
      privateIsOpen,
    }

  }
}


